import React from "react";
import { connect, ConnectedProps } from "react-redux";
import { openContentPopup } from "../../store/actions";

interface IProps {
  tabs: any[];
}

const mapDispatchToProps = (dispatch: any) => ({
  openContentPopupDispatch:
    (contentPopupOptions: any) => dispatch(openContentPopup(contentPopupOptions))
});

const connector = connect(null, mapDispatchToProps);

const SubMenu = ({
  tabs,
  openContentPopupDispatch
}: IProps & ConnectedProps<typeof connector>) => (
  <ul className="tabs fixed-menu sticky-tabs" style={{ margin: "0" }}>
    {
      tabs.map(t => (
        <li
          className={`${t.active ? "active" : ""} ${t.disabled ? "disabled" : ""}`}>
          <a
            className="tab"
            onClick={() => !t.disabled && openContentPopupDispatch({
              name: t.name,
              title: t.title,
              icon: t.icon,
              label: t.label,
              ...t.parameters
            })}
          >
            {t.label}
          </a>
        </li>
      ))
    }
  </ul>
);

export default connector(SubMenu);
